export enum ReportsRoutesEnum {
  Reports = '/home/reports',
  FiscalAccumulatorTasksReport = '/home/reports/fiscal-accumulator',
  MtsrReport = '/home/reports/mtsr',
}
